import {
  Button,
  ButtonVariants,
  CopyPlusIcon,
  Modal,
  ModalStage,
  Text,
  useModalContext
} from 'stubben-edge-unified-frontend-react-components';
import { CAMPAIGN_DUPLICATE_MODAL } from '@/constants/modals';

export interface DuplicateModalProps {
  onConfirm: () => void;
  isPending?: boolean;
  campaignName?: string;
}

function DuplicateModal({
  onConfirm,
  isPending = false,
  campaignName
}: DuplicateModalProps) {
  const modal = useModalContext();

  const handleClose = () => {
    if (!isPending) {
      modal.close(CAMPAIGN_DUPLICATE_MODAL);
    }
  };

  return (
    <Modal name={CAMPAIGN_DUPLICATE_MODAL} testIdentifier="campaign-duplicate-modal">
      <ModalStage
        title="Duplicate campaign?"
        leftSlot={<CopyPlusIcon size={32} className="text-primary" />}
        testIdentifier="campaign-duplicate-modal-stage"
        handleClose={handleClose}
        actions={
          <div className="flex w-full items-center justify-end gap-4">
            <Button
              variant={ButtonVariants.Secondary}
              onClick={handleClose}
              disabled={isPending}
              testIdentifier="campaign-duplicate-modal-cancel"
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={onConfirm}
              loading={isPending}
              disabled={isPending}
              testIdentifier="campaign-duplicate-modal-confirm"
            >
              Duplicate
            </Button>
          </div>
        }
      >
        <Text variant="tertiary" size="md">
          This will create a new draft copy
          {campaignName ? ` of "${campaignName}"` : ''}, including campaign
          content, schedule settings, conversion events, and workflow when
          present. The original campaign will not be changed.
        </Text>
      </ModalStage>
    </Modal>
  );
}

export default DuplicateModal;
